import {
   CurrentHealthcareProviderNfzConfigurationQuery,
   HealthcareProviderNfzConfiguration,
} from '@dreryk/egabinet-nfz-configuration-frontend-api';

import { useCqrsFind, UseCqrsQueryResult } from '@dreryk/command-query-react-common';

export const useCqrsFindHealthcareProviderNfzConfiguration = (): UseCqrsQueryResult<HealthcareProviderNfzConfiguration | null> => {
   return useCqrsFind(() => new CurrentHealthcareProviderNfzConfigurationQuery(), {
      cacheTime: 'short',
   });
};
